import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { compose } from 'recompose'
import { FormattedDate } from 'components/intl'
import { get } from 'lodash'
import { Link } from 'react-router-dom'

import { Table, Data } from 'components/layout/Table'
import { tasks } from 'constants/layout'
import { meta, tableCommon } from 'helpers/decorators'
import {
  apiEmailRevision
} from 'helpers/decorators/api'
import { modal } from 'redux/modules/app'
import { Modal } from 'containers/misc'
import { TasksEmailRevisionReason } from 'components/sections/tasks'
import { Button, ButtonGroup } from 'components/misc'
import { TaskEmailRevisionClear, TaskEmailRevise } from 'containers/forms/tasks'
import uuid from 'uuid'
import config from 'config'

const enhance = compose(
  meta({
    title: 'Tasks - Undelivered Emails',
    intlKey: 'pageTitle.tasks_undelivered_emails'
  }),
  apiEmailRevision({
    emailRevision: true,
    useCommonLimit: true
  }),
  tableCommon(),
  connect(
    ({ auth }) => ({
      activeOrganizationId: auth.organization.id
    }),
    { modal }
  )
)

class TasksEmailRevision extends Component {
  static propTypes = {
    tasks: PropTypes.object.isRequired,
    modal: PropTypes.func.isRequired,
    setTasksEmailRevisionParams: PropTypes.func,
    clearEmailRevision: PropTypes.func,
    canNotifyEmailRevision: PropTypes.func,
    notifyEmailRevision: PropTypes.func,
    setCommonLimit: PropTypes.func
  }

  constructor (props) {
    super(props)
    this.key = uuid.v1()
    this.state = {
      emailClearId: null,
      emailNotifyId: null,
      actionRequest: null,
      reason: ''
    }
  }

  handleShowReason = reason => {
    this.setState(
      {
        reason
      },
      () => {
        this.props.modal(`modal-reason-show-${this.key}`)
      }
    )
  }

  handleClearEmailRevisionModal = emailClearId => {
    this.setState(
      {
        emailClearId
      },
      () => {
        this.props.modal(`modal-email-clear-${this.key}`)
      }
    )
  }

  handleNotifyEmailRevisionModal = (emailNotifyId, actionRequest) => {
    this.setState(
      {
        emailNotifyId,
        actionRequest
      },
      () => {
        this.props.modal(`modal-email-notify-${this.key}`)
      }
    )
  }

  render () {
    const {
      tasks: { emailRevision: { loading, list, offset, limit, pages, sort } },
      setTasksEmailRevisionParams,
      clearEmailRevision,
      notifyEmailRevision,
      canNotifyEmailRevision,
      setCommonLimit
    } = this.props

    return (
      <div>
        <Table
          loading={loading}
          length={list.length}
          offset={offset}
          limit={limit}
          onSetLimit={setCommonLimit}
          pages={pages}
          sort={sort}
          ths={tasks.emailRevision}
          setParams={setTasksEmailRevisionParams}
        >
          <Data>
            {list.map(item => (
              <tr key={item.id}>
                <td>{item.category}</td>
                <td>{item.advice}</td>
                <td>{item.email}</td>
                <td>
                  {item.reason && <Button
                    type="button"
                    link
                    intlKey="button.view"
                    onClick={() => this.handleShowReason(item.reason)}
                  >
                    View
                  </Button>}
                </td>
                <td>{get(item, 'participant.name')}</td>
                <td>
                  <Link to={`${config.publicPath}/participants/${get(item, 'participant.id')}`}>
                    {get(item, 'participant.globalId') ||
                    get(item, 'participant.id')}
                  </Link>
                </td>
                <td>{item.sendDate && <FormattedDate value={item.sendDate} />}</td>
                <td>
                  <ButtonGroup>
                    <Button
                      onClick={() =>
                        this.handleClearEmailRevisionModal(item.id)}
                      intlKey="button.clear"
                      dataTestId="clearEmailRevisionButton"
                      tiny
                    >
                      Clear
                    </Button>
                    {canNotifyEmailRevision(item) && <Button
                      onClick={() =>
                        this.handleNotifyEmailRevisionModal(item.id, item.actionRequest)}
                      intlKey="button.notify_participant"
                      dataTestId="notifyEmailRevisionButton"
                      tiny
                    >
                      Notify participant
                    </Button>}
                  </ButtonGroup>
                </td>
              </tr>
            ))}
          </Data>
        </Table>
        <Modal
          id={`modal-reason-show-${this.key}`}
          closeAction="Close"
          intlKeyClose="modal.close"
        >
          <TasksEmailRevisionReason reason={this.state.reason} />
        </Modal>
        <Modal id={`modal-email-clear-${this.key}`} customActions>
          <TaskEmailRevisionClear
            proceed={clearEmailRevision}
            id={this.state.emailClearId}
            modal={this.props.modal}
          />
        </Modal>
        <Modal id={`modal-email-notify-${this.key}`} customActions>
          <TaskEmailRevise
            proceed={notifyEmailRevision}
            id={this.state.emailNotifyId}
            actionRequest={this.state.actionRequest}
            modal={this.props.modal}
          />
        </Modal>
      </div>
    )
  }
}

export default enhance(TasksEmailRevision)

